function ProgressBarLoadingIndicator(): JSX.Element {
  return (
    <div
      className={
        "px-6 lg:px-[109px] bg-white sticky top-0 py-6 z-[889] bg-dropDownBorder"
      }
    >
      <div className="transition-all animate-pulse bg-dropDownBorder mb-2 p-2 w-[20px] rounded-full" />
      <div className="w-full bg-[#DCDFE4] rounded-full overflow-hidden p-2" />
    </div>
  );
}
export default ProgressBarLoadingIndicator;
